import React, { useState, useCallback, useRef, useEffect, Fragment } from "react";
import TableCellRank from "../table/TableCellRank";
import Utils from "../../utils/Utils";
import Checkbox from "../form/Checkbox";
import TableSkeleton from "../table/TableSkeleton";
import Tooltip from "../tooltip/Tooltip";
const skeletonTableHeader = [
  {
    title: "ShotTypes",
    showImage: false,
    sortable: false,
    key: "ShotTypes",
  },
  {
    title: "Freq %",
    showImage: false,
    sortable: false,
    key: "Freq %",
  },
  {
    title: "FG %",
    showImage: false,
    sortable: false,
    key: "FG %",
  },
  {
    title: "SQ FG %",
    showImage: false,
    sortable: false,
    key: "SQ FG %",
  },
];

const TeamContestData = ({ data, leagueType, year, conferenceTeamCount = 0, loading = false }) => {
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [activeType, setActiveType] = useState({});
  const shotTypeCheckboxRef = useRef(null);

  const handleCheckboxClick = useCallback(
    (e) => {
      if (e.target.checked) {
        setCheckboxChecked(true);
        setActiveType({});
      } else {
        setCheckboxChecked(false);
        setActiveType({});
      }
    },
    [checkboxChecked]
  );

  useEffect(() => {
    if (checkboxChecked) {
      setActiveType({});
    } else {
      setActiveType({});
    }
  }, [checkboxChecked]);

  const rankConfig = {
    leagueType: leagueType,
    conferenceTeamCount: 0,
  };
  return (
    <>
      <div className="row">
        <div className="col-8 text-left ">
          <h4 style={{ fontSize: 36, fontFamily: "var(--font-oswald)" }}>Offensive Contest Data</h4>
        </div>

        {/* <div className="col-4 text-center">
        <Checkbox
          id="shottypeConferenceOnlyCheck"
          ref={shotTypeCheckboxRef}
          onClick={handleCheckboxClick}
          label="Conference Only"
          checked={shotTypeCheckboxRef?.current?.checked}
        />
      </div> */}

        {loading ? <TableSkeleton tableHeader={skeletonTableHeader} tableRowsCount={15} /> : null}

        {!loading ? (
          <div className="table-responsive p-3">
            <table className="table">
              <thead className="sticky-th-2">
                <tr>
                  <th rowSpan="2">ShotTypes</th>
                  <th className="sticky-th-2">Freq %</th>
                  <th className="sticky-th-2">FG %</th>
                  <th className="sticky-th-2">SQ FG %</th>
                </tr>
              </thead>
              <tbody>
                {/* <tr>
                  <td style={{ color: "#0F131B", fontWeight: "bold" }}>Open Layups</td>
                  <TableCellRank rankValue={data?.["freq_open_layup_offense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["freq_open_layup_offense"])}
                  </TableCellRank>
                  <TableCellRank
                    rankValue={data?.["fg_pct_open_layup_offense_rank"]}
                    {...rankConfig}
                    hideGradients={true}
                  >
                    {Utils.toPercent(data["fg_pct_open_layup_offense"])}
                  </TableCellRank>
                  <TableCellRank rankValue={data?.["sq_fg_pct_open_layup_offense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["sq_fg_pct_open_layup_offense"])}
                  </TableCellRank>
                </tr>
                <tr>
                  <td style={{ color: "#0F131B", fontWeight: "bold" }} title="">
                    Contested Layups
                  </td>
                  <TableCellRank rankValue={data?.["freq_contested_layup_offense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["freq_contested_layup_offense"])}
                  </TableCellRank>
                  <TableCellRank
                    rankValue={data?.["fg_pct_contested_layup_offense_rank"]}
                    {...rankConfig}
                    hideGradients={true}
                  >
                    {Utils.toPercent(data["fg_pct_contested_layup_offense"])}
                  </TableCellRank>
                  <TableCellRank rankValue={data?.["sq_fg_pct_contested_layup_offense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["sq_fg_pct_contested_layup_offense"])}
                  </TableCellRank>
                </tr> */}

                {/* <tr>
                  <td style={{ color: "#0F131B", fontWeight: "bold" }} title="">
                    Open Midrange Shots
                  </td>
                  <TableCellRank rankValue={data["freq_open_midrange_offense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["freq_open_midrange_offense"])}
                  </TableCellRank>
                  <TableCellRank rankValue={data["fg_pct_open_midrange_offense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["fg_pct_open_midrange_offense"])}
                  </TableCellRank>
                  <TableCellRank rankValue={data["sq_fg_pct_open_midrange_offense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["sq_fg_pct_open_midrange_offense"])}
                  </TableCellRank>
                </tr>
                <tr>
                  <td style={{ color: "#0F131B", fontWeight: "bold" }} title="">
                    Contested Midrange Shots
                  </td>
                  <TableCellRank rankValue={data["freq_contested_midrange_offense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["freq_contested_midrange_offense"])}
                  </TableCellRank>
                  <TableCellRank rankValue={data["fg_pct_contested_midrange_offense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["fg_pct_contested_midrange_offense"])}
                  </TableCellRank>
                  <TableCellRank rankValue={data["sq_fg_pct_contested_midrange_offense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["sq_fg_pct_contested_midrange_offense"])}
                  </TableCellRank>
                </tr> */}
                <tr>
                  <td style={{ color: "#0F131B", fontWeight: "bold" }}>
                    Open FG3A <Tooltip text="When there are no defenders within 8 feet" />
                  </td>
                  <TableCellRank rankValue={data?.["freq_open_fg3a_offense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["freq_open_fg3a_offense"])}
                  </TableCellRank>
                  <TableCellRank
                    rankValue={data?.["fg_pct_open_fg3a_offense_rank"]}
                    {...rankConfig}
                    hideGradients={true}
                  >
                    {Utils.toPercent(data["fg_pct_open_fg3a_offense"])}
                  </TableCellRank>
                  <TableCellRank rankValue={data?.["sq_fg_pct_open_fg3a_offense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["sq_fg_pct_open_fg3a_offense"])}
                  </TableCellRank>
                </tr>
                <tr>
                  <td style={{ color: "#0F131B", fontWeight: "bold" }} title="">
                    Contested FG3A <Tooltip text="When there is 1 or more defenders within 8 feet of the shooter" />
                  </td>
                  <TableCellRank rankValue={data?.["freq_contested_fg3a_offense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["freq_contested_fg3a_offense"])}
                  </TableCellRank>
                  <TableCellRank
                    rankValue={data?.["fg_pct_contested_fg3a_offense_rank"]}
                    {...rankConfig}
                    hideGradients={true}
                  >
                    {Utils.toPercent(data["fg_pct_contested_fg3a_offense"])}
                  </TableCellRank>
                  <TableCellRank rankValue={data?.["sq_fg_pct_contested_fg3a_offense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["sq_fg_pct_contested_fg3a_offense"])}
                  </TableCellRank>
                </tr>
              </tbody>
            </table>
          </div>
        ) : null}
      </div>
      <div className="row">
        <div className="col-8 text-left ">
          <h4 style={{ fontSize: 36, fontFamily: "var(--font-oswald)" }}>Defensive Contest Data</h4>
        </div>
        {loading ? <TableSkeleton tableHeader={skeletonTableHeader} tableRowsCount={15} /> : null}

        {!loading ? (
          <div className="table-responsive p-3">
            <table className="table">
              <thead className="sticky-th-2">
                <tr>
                  <th rowSpan="2">ShotTypes</th>
                  <th className="sticky-th-2">Freq %</th>
                  <th className="sticky-th-2">FG %</th>
                  <th className="sticky-th-2">SQ FG %</th>
                </tr>
              </thead>
              <tbody>
                {/* <tr>
                  <td style={{ color: "#0F131B", fontWeight: "bold" }}>Open Layups</td>
                  <TableCellRank rankValue={data?.["freq_open_layup_defense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["freq_open_layup_defense"])}
                  </TableCellRank>
                  <TableCellRank
                    rankValue={data?.["fg_pct_open_layup_defense_rank"]}
                    {...rankConfig}
                    hideGradients={true}
                  >
                    {Utils.toPercent(data["fg_pct_open_layup_defense"])}
                  </TableCellRank>
                  <TableCellRank rankValue={data?.["sq_fg_pct_open_layup_defense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["sq_fg_pct_open_layup_defense"])}
                  </TableCellRank>
                </tr>
                <tr>
                  <td style={{ color: "#0F131B", fontWeight: "bold" }} title="">
                    Contested Layups
                  </td>
                  <TableCellRank rankValue={data?.["freq_contested_layup_defense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["freq_contested_layup_defense"])}
                  </TableCellRank>
                  <TableCellRank rankValue={data?.["fg_pct_contested_layup_defense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["fg_pct_contested_layup_defense"])}
                  </TableCellRank>
                  <TableCellRank rankValue={data?.["sq_fg_pct_contested_layup_defense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["sq_fg_pct_contested_layup_defense"])}
                  </TableCellRank>
                </tr>

                <tr>
                  <td style={{ color: "#0F131B", fontWeight: "bold" }} title="">
                    Open Midrange Shots
                  </td>
                  <TableCellRank rankValue={data["freq_open_midrange_defense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["freq_open_midrange_defense"])}
                  </TableCellRank>
                  <TableCellRank rankValue={data["fg_pct_open_midrange_defense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["fg_pct_open_midrange_defense"])}
                  </TableCellRank>
                  <TableCellRank rankValue={data["sq_fg_pct_open_midrange_defense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["sq_fg_pct_open_midrange_defense"])}
                  </TableCellRank>
                </tr>
                <tr>
                  <td style={{ color: "#0F131B", fontWeight: "bold" }} title="">
                    Contested Midrange Shots
                  </td>
                  <TableCellRank rankValue={data["freq_contested_midrange_defense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["freq_contested_midrange_defense"])}
                  </TableCellRank>
                  <TableCellRank rankValue={data["fg_pct_contested_midrange_defense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["fg_pct_contested_midrange_defense"])}
                  </TableCellRank>
                  <TableCellRank rankValue={data["sq_fg_pct_contested_midrange_defense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["sq_fg_pct_contested_midrange_defense"])}
                  </TableCellRank>
                </tr> */}
                <tr>
                  <td style={{ color: "#0F131B", fontWeight: "bold" }}>
                    Open FG3A <Tooltip text="When there are no defenders within 8 feet" />
                  </td>
                  <TableCellRank rankValue={data?.["freq_open_fg3a_defense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["freq_open_fg3a_defense"])}
                  </TableCellRank>
                  <TableCellRank
                    rankValue={data?.["fg_pct_open_fg3a_defense_rank"]}
                    {...rankConfig}
                    hideGradients={true}
                  >
                    {Utils.toPercent(data["fg_pct_open_fg3a_defense"])}
                  </TableCellRank>
                  <TableCellRank rankValue={data?.["sq_fg_pct_open_fg3a_defense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["sq_fg_pct_open_fg3a_defense"])}
                  </TableCellRank>
                </tr>
                <tr>
                  <td style={{ color: "#0F131B", fontWeight: "bold" }} title="">
                    Contested FG3A <Tooltip text="When there is 1 or more defenders within 8 feet of the shooter" />
                  </td>
                  <TableCellRank rankValue={data?.["freq_contested_fg3a_defense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["freq_contested_fg3a_defense"])}
                  </TableCellRank>
                  <TableCellRank rankValue={data?.["fg_pct_contested_fg3a_defense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["fg_pct_contested_fg3a_defense"])}
                  </TableCellRank>
                  <TableCellRank rankValue={data?.["sq_fg_pct_contested_fg3a_defense_rank"]} {...rankConfig}>
                    {Utils.toPercent(data["sq_fg_pct_contested_fg3a_defense"])}
                  </TableCellRank>
                </tr>
              </tbody>
            </table>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default TeamContestData;
